var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
import Link from '../link/Link';
var StyledItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 20px;\n  color: ", ";\n  background-color: #fff;\n"])), function (props) {
  return props.color;
});
StyledItem.displayName = 'StyledItem';
var StyledLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  color: #3380A7;\n"])));
StyledItem.displayName = 'StyledLink';

var ListGroupItem = function ListGroupItem(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'li' : _ref$as,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#42484d' : _ref$color,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? null : _ref$href,
      restProps = _objectWithoutProperties(_ref, ["as", "children", "className", "color", "dataAnalyticsId", "dataAnalyticsLabel", "href"]);

  var isLink = as === 'a';
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLink && /*#__PURE__*/React.createElement(StyledItem, _extends({
    as: StyledLink,
    href: href,
    target: "_blank",
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    className: "scl-list-link-item ".concat(className),
    "data-test-id": "scl-list-link-item"
  }, restProps), children), !isLink && /*#__PURE__*/React.createElement(StyledItem, {
    className: "scl-list-group-item ".concat(className),
    color: color,
    "data-test-id": "scl-list-group-item"
  }, children));
};

ListGroupItem.propTypes = {
  /**
   Required and consists of everything between opening and closing tags when invoking component
  */
  children: node.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Optional to control color of text
  */
  color: string,

  /**
   Unique id for analytics tracking. Required when item is a link.
  */
  dataAnalyticsId: string,

  /**
   Optional label for analytics tracking.
  */
  dataAnalyticsLabel: string,

  /**
   Optional to render ListGroup.Item as a link.
  */
  as: string,

  /**
   Url when rendering ListGroup.Item as a link.
  */
  href: string
};
export default ListGroupItem;